import React from 'react'

function EmployeeName({row , i}) {
  return (
    <>{row?.employee?.employeeCode}</>
  )
}

export default EmployeeName